import { DemoApiMock } from '../types'
import { getDemoData, matchRestRequest, setDemoData } from '../utils'
import { WorkShift } from 'typings/common_defs'
import { formatInTimeZone } from 'date-fns-tz'

interface EditShiftTimesPayload {
  shift_ids: number[]
  starts_at: string
  ends_at: string
  lunch_length: number
}

export const mockAssignmentEditShiftTimes: DemoApiMock = {
  shouldMock: (request) =>
    matchRestRequest(
      request,
      /\/company\/\d+\/assignment\/\d+\/shifts$/,
      'PUT'
    ),
  getResponse: async (request) => {
    const payload = request.data as EditShiftTimesPayload
    const { shift_ids, starts_at, ends_at, lunch_length } = payload
    const demoData = getDemoData()

    // Update each affected shift
    const updatedShifts = demoData.shifts.map((s) => {
      if (!shift_ids.includes(s.id)) {
        return s
      }

      const currentShift = s as WorkShift
      const timezone = currentShift.location?.address?.timezone ?? 'UTC'

      if (!currentShift.startsAt) {
        return currentShift
      }

      // Get the original shift's date in the shift's timezone
      const originalDate = formatInTimeZone(
        new Date(currentShift.startsAt),
        timezone,
        'yyyy-MM-dd'
      )

      // Extract time portions from the payload timestamps
      const startTime = formatInTimeZone(
        new Date(starts_at),
        timezone,
        'HH:mm:ss'
      )
      const endTime = formatInTimeZone(new Date(ends_at), timezone, 'HH:mm:ss')

      // Create new start and end times using original date
      const newStartTime = new Date(`${originalDate}T${startTime}`)
      const newEndTime = new Date(`${originalDate}T${endTime}`)

      // If end time is before start time, it's an overnight shift
      if (newEndTime < newStartTime) {
        newEndTime.setDate(newEndTime.getDate() + 1)
      }

      return {
        ...currentShift,
        startsAt: newStartTime.toISOString(),
        endsAt: newEndTime.toISOString(),
        lunchLength: lunch_length,
      }
    })

    setDemoData({
      ...demoData,
      shifts: updatedShifts,
    })

    return {
      data: {
        success: true,
        message: `Updated times for ${shift_ids.length} shifts`,
        shifts: shift_ids.map((shiftId) => {
          const shift = updatedShifts.find((s) => s.id === shiftId) as WorkShift
          return {
            id: shiftId,
            startsAt: shift.startsAt,
            endsAt: shift.endsAt,
            lunchLength: shift.lunchLength,
          }
        }),
      },
    }
  },
}
